// src/utils/formatoNumeros.js

/**
 * Formatea un número al estilo Paraguay:
 *  - 2000000 → "2.000.000"
 */
export function formatoPy(value) {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("es-PY");
}

/**
 * Convierte un string formateado a número crudo:
 *  - "2.000.000" → "2000000"
 */
export function parsePy(value) {
  if (!value) return "";
  return value.replace(/\./g, "");
}

/**
 * Valida si el valor ingresado contiene solo dígitos y puntos.
 */
export function isPyNumeric(value) {
  return /^[0-9.]*$/.test(value || "");
}
